import { render, staticRenderFns } from "./CommentTree.vue?vue&type=template&id=4081f3d4&"
import script from "./CommentTree.vue?vue&type=script&lang=ts&"
export * from "./CommentTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports